<div
    align="center"
    class="fuse-splash-screen"
    style="justify-content: center; align-self: center; width: 100%; padding: 24px; z-index: 10000">
    @if (showImage()) {
        <img alt="" width="300" height="72" src="assets/images/logos/logo_main.avif" />
    }
    <div class="center">
        <div class="spinner-wrapper">
            <div class="spinner">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
            </div>
        </div>
        <!-- / Material Design Spinner -->
    </div>
</div>
